import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/countries/translation.updateCountry.mutation.gql"
import type {
  TranslationUpdateCountryMutation,
  TranslationUpdateCountryMutationVariables,
} from "@/v2-backoffice-client/translation/countries/__types__/translation.updateCountry.mutation"

type Options = MutationHookOptions<
  TranslationUpdateCountryMutation,
  TranslationUpdateCountryMutationVariables
>

export function useTranslationUpdateCountryMutation(options?: Options) {
  return useMutation<
    TranslationUpdateCountryMutation,
    TranslationUpdateCountryMutationVariables
  >(mutation, {
    // Supporting a country changes which options every feature's country
    // availability list offers, so the pickers have to re-read too.
    refetchQueries: ["TranslationCountriesQuery", "CountryQuery"],
    ...options,
  })
}
